export const Functions = {
  create: false,
  delete: false,
  detail: true,
  search: true,
};

export const PageName = '绿途币交易列表';
